'use client';
import { FiberManualRecord } from '@mui/icons-material';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  styled,
} from '@mui/material';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';


const ListItemInline = styled(ListItem)(({ theme }) => ({
  width: 'auto',
  display: 'inline-flex',
  padding: theme.spacing(0, 0),
  height: '15px'
}));

export function ChartLegend() {
  return (
    <List disablePadding>
      <ListItemInline>
        <ListItemIcon sx={{ minWidth: 20 }}>
          <FiberManualRecord
            sx={{ color: '#5AADE3', fontSize: '10px' }}
          />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant={'body1'} fontSize={'10px'} sx={{ fontSize: { xs: 11, md: 13 }}}>
              Used
            </Typography>
          }
        />
      </ListItemInline>
      <ListItemInline>
        <ListItemIcon sx={{ minWidth: 20 }}>
          <FiberManualRecord
            sx={{ color: '#E0E0E0', fontSize: '10px' }}
          />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant={'body1'} fontSize={'10px'} sx={{ fontSize: { xs: 11, md: 13 }}}>
              Remaining
            </Typography>
          }
        />
      </ListItemInline>
    </List>
  );
};

export function Chart({ used }: { used: number }) {
  const data: any[] = [
    { name: 'Used', value: used, color: '#5AADE3' },
    { name: 'Remaining', value: 100 - used, color: '#E0E0E0' },
  ];
  return (
    <ResponsiveContainer width='100%' height='100%'>
      <PieChart>
        <text
          x='50%'
          className='h1'
          y='50%'
          textAnchor='middle'
          dominantBaseline='middle'
        />
        <Pie
          data={data}
          dataKey='value'
          cx='50%'
          cy='50%'
          innerRadius={20}
          outerRadius={35}
          fill='#8884d8'
        >
          {data.map((item, index) => (
            <Cell key={index} fill={item.color} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
}
